import { normalizeLookupCode } from 'utils/product-codes/lib/catalogNormalizeLookupCodes'

export const normalizeProductCode = (code: string) => normalizeLookupCode(code)

export const normalizeProductCodes = (codes: string[]) =>
  codes.map(code => normalizeLookupCode(code))
